import { useEffect, useRef, useState } from 'react'
import { avancarQuatroImpactos } from '../../dominio/didatico/quatroImpactos'

export function useQuatroImpactos() {
  const [tempo, setTempo] = useState(0)
  const [reproduzindo, setReproduzindo] = useState(false)
  const [pausarPorImpacto, setPausarPorImpacto] = useState(true)
  const [velocidade, setVelocidade] = useState(0.5)
  const tempoRef = useRef(tempo)

  useEffect(() => {
    if (!reproduzindo) return
    let anterior: number | null = null
    let id = 0
    const quadro = (agora: number) => {
      const delta = anterior === null ? 0 : Math.min((agora - anterior) / 1000, 0.25)
      anterior = agora
      const proximo = avancarQuatroImpactos(tempoRef.current, delta * velocidade / 16, pausarPorImpacto)
      tempoRef.current = proximo.tempo
      setTempo(proximo.tempo)
      if (proximo.pausar) { setReproduzindo(false); return }
      id = requestAnimationFrame(quadro)
    }
    id = requestAnimationFrame(quadro)
    const suspender = () => { if (document.hidden) setReproduzindo(false) }
    document.addEventListener('visibilitychange', suspender)
    return () => { cancelAnimationFrame(id); document.removeEventListener('visibilitychange', suspender) }
  }, [reproduzindo, pausarPorImpacto, velocidade])

  const irPara = (t: number) => {
    setReproduzindo(false)
    tempoRef.current = Math.max(0, Math.min(1, t))
    setTempo(tempoRef.current)
  }
  const alternar = () => {
    if (!reproduzindo && tempoRef.current >= 1) { tempoRef.current = 0; setTempo(0) }
    setReproduzindo(!reproduzindo)
  }
  return { tempo, reproduzindo, pausarPorImpacto, setPausarPorImpacto, velocidade, setVelocidade, irPara, alternar }
}
